import * as React from 'react'
import './icon.scss'

interface IconProps {
  icon: string,
  className?: string
  style?: React.CSSProperties
  onClick?: () => void
}

export class Icon extends React.Component<IconProps> {
  render(): React.ReactNode {
    return (
      <i
        className={`icon-${this.props.icon} ${this.props.className || ''}`}
        style={this.props.style}
        aria-hidden="true"
        onClick={this.props.onClick}
      />
    )
  }
}
